
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsuarioMDCService {

  url = environment.url + '/usuarios-mdcs';

  constructor(private http: HttpClient) {}

  getAll(username: string, cliente: string) {
    let headers = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Autorizzazione', localStorage.getItem('token'));

    return this.http.get(`${ this.url }/all?usuario=${ username }&cliente=${ cliente }`, { headers }).pipe( map( data => data));
  }
}
